export default {
	styleOverrides: {
		input: {
			padding: 0,
		},
		root: ({ theme }) => ({
			padding: '8px 12px',
			color: (theme.vars || theme).palette.text.primary,
			borderRadius: (theme.vars || theme).shape.borderRadius,
			border: `1px solid ${(theme.vars || theme).palette.divider}`,
			backgroundColor: (theme.vars || theme).palette.background.default,
			transition: 'border 120ms ease-in',
			'& .MuiInputBase-input': {
				color: theme.palette.black, // Default text color
				'&::placeholder': {
					color: theme.palette.black, // Placeholder text color
					opacity: 0.8, // Ensure full visibility of placeholder
				},
			},
			'& .MuiOutlinedInput-notchedOutline': {
				borderColor: theme.palette.black,
				transition: 'border-color 200ms cubic-bezier(0.4, 0, 0.2, 1)',
			},
			'&:hover .MuiOutlinedInput-notchedOutline': {
				borderColor: theme.palette.black,
			},
			'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
				borderColor: theme.palette.black,
				borderWidth: '0.5px', // Optionally override the default 2px focus border
			},
			// Add disabled state
			'&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
				borderColor: theme.palette.action.disabled,
			},
			'&.Mui-disabled .MuiInputBase-input': {
				color: theme.palette.action.disabled, // Disabled input text color
			},
		}),
	},
}
